<template>
  <div class="image-gallery padding--top-4 padding--bottom-4"
       :class="{ 'view': visible }"
       v-scroll:in="() => { visible = true; loaded = true; }"
       v-scroll:out="() => visible = false">
    <div class="position-relative">
      <swiper :ref="swiper" :options="options">
        <swiper-slide v-for="item in gallery.entries" :key="item.handle">
          <div>
            <div class="bgimg--hover">
              <div class="fade-in-child">
                <background-image
                  :scale="'16-9'"
                  :url="`https://media.graphcms.com/resize=w:1200,fit:crop/quality=value:70/compress/${item.handle}`"
                  :loaded="loaded"/>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="image-gallery__button image-gallery__button--prev"
           :class="{'image-gallery__button--disabled': this.gallery.entries.length <= 1}">
        <svg class="image-gallery__icon image-gallery__icon--prev" fill="currentColor" height="12" viewBox="0 0 8 12" width="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"><path d="m7.41 10.59-4.58-4.59 4.58-4.59-1.41-1.41-6 6 6 6z" transform="matrix(-1 0 0 -1 8 12)"></path></svg>
      </div>
      <div class="image-gallery__button image-gallery__button--next"
           :class="{'image-gallery__button--disabled': this.gallery.entries.length <= 1}">
        <svg class="image-gallery__icon" fill="currentColor" height="12" viewBox="0 0 8 12" width="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"><path d="m7.41 10.59-4.58-4.59 4.58-4.59-1.41-1.41-6 6 6 6z" transform="matrix(-1 0 0 -1 8 12)"></path></svg>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import BackgroundImage from './layout/BackgroundImage';
import Settings from '../config/settings';

export default {
  name: 'ImageGallery',
  components: { BackgroundImage },
  props: {
    id: {
      type: String,
      required: false
    },
    dataObj: {
      type: Object,
      default: null,
      required: false
    },
    slidesPerView: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      gallery: {
        entries: []
      },
      swiper: false,
      loaded: false,
      visible: false,
      options: {
        autoplay: {
          delay: 4000
        },
        navigation: {
          prevEl: '.image-gallery__button--prev',
          nextEl: '.image-gallery__button--next'
        },
        slidesPerView: 1,
        breakpoints: {
          480: {
            slidesPerView: this.slidesPerView
          }
        }
      }
    };
  },
  methods: {
    async fetchModuleGallery () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=moduleGallery&id=${this.id}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.gallery.entries = response.moduleGallery.gallery;
        });
    }
  },
  created () {
    if (this.id) {
      this.fetchModuleGallery();
    }
    if (this.dataObj !== null) {
      this.gallery.entries = this.dataObj.gallery;
    }
  }
};
</script>

<style lang="scss" scoped>
  .image-gallery {
    &__button {
      position: absolute;
      top: 50%;
      margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      &--prev {
        left: -40px;
        right: auto;
      }
      &--next {
        left: auto;
        right: -40px;
      }
      &--disabled {
        display: none;
      }
    }
    &__icon {
      width: 24px;
      height: 24px;
      &--prev {
        transform: rotate(180deg);
      }
    }
  }
  @media all and (max-width: map_get($grid-breakpoints, 'md')) {
    .image-gallery {
      &__button {
        display: none;
      }
    }
  }
</style>
